import { createSelector } from 'reselect';
const selectUser = (state) => state.user;

export const selectCurrentUser = createSelector(
    [selectUser],
    (user) => user.currentUser
);

export const selectCurrentUserRoles = createSelector(
    [selectUser],
    (user) => user.userRoles
);

export const selectActiveRole = createSelector(
    [selectUser],
    (user) => user.activeRole
);